import { ImageLoaderProps } from "next/image"
import { AnswerDetailFragment, Maybe } from "../graphql/generated/graphql"
import { GetFilenameRegex } from "../constants"
import { RemoveQueryStringsRegex } from "../constants"

export const PublicLoader = ({ src }: ImageLoaderProps) => {
  let domain = "https://joinbonsai.co"
  if (process.env.NEXT_PUBLIC_ENV === "development") {
    domain = ""
  } else if (process.env.NEXT_PUBLIC_ENV === "staging") {
    domain = "https://staging.joinbonsai.co"
  } else if (process.env.NEXT_PUBLIC_ENV === "playground") {
    domain = "https://playground.joinbonsai.co"
  }
  return `${domain}${src}`
}

export const MediaTranscodesLoader = ({ src }: ImageLoaderProps) => {
  return `https://${process.env.NEXT_PUBLIC_AWS_MEDIA_TRANSCODES_BUCKET}.s3.amazonaws.com/${src}`
}

export const ProfileImageLoader = ({ src }: ImageLoaderProps) => {
  return `https://${process.env.NEXT_PUBLIC_AWS_PROFILE_PICTURE_BUCKET}.s3.amazonaws.com/${src}`
}

export const CoverImageLoader = ({ src, width }: ImageLoaderProps) => {
  return `https://${process.env.NEXT_PUBLIC_AWS_PROFILE_PICTURE_BUCKET}.s3.amazonaws.com/${src}?w=${width}`
}

export const MediaTranscodeMp4 = (Answer: AnswerDetailFragment) => {
  const id = Answer.questionId
  return `https://${process.env.NEXT_PUBLIC_AWS_MEDIA_TRANSCODES_BUCKET}.s3.amazonaws.com/${id}.mp4`
}

export const MediaTranscodeFilename = (Answer: Maybe<AnswerDetailFragment | undefined>) => {
  const fallback = `bonsai-coming-soon.png` // establishes fallback image
  if (Answer && Answer.coverImage) {
    const coverImage = Answer.coverImage // gets the cover image URL from the DB
    const match = GetFilenameRegex.exec(coverImage) // isolate the filename
    const filenameQuery = match ? match[1] : fallback
    const file = RemoveQueryStringsRegex.exec(filenameQuery) // remove any query params
    const filename = file ? file[1] : fallback
    return filename // returns a clean filename
  }
  return fallback
}
